import {
  AddNoteActionTypes,
  ADD_NOTE_FAIL,
  ADD_NOTE_LOADING,
  ADD_NOTE_SUCCESS,
  AddNoteState,
  ADD_NOTE_UPDATE_API_MSG,
  ADD_NOTE_UPDATE_API_RES,
} from "./ActionTypes";
import { AddNoteRes } from "./Model";

const initialStateGetPosts: AddNoteState = {
  loading: false,
  AddNoteRes: {} as AddNoteRes,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const AddNoteReducer = (
  state = initialStateGetPosts,
  action: AddNoteActionTypes
): AddNoteState => {
  switch (action.type) {
    case ADD_NOTE_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case ADD_NOTE_SUCCESS:
      return {
        ...state,
        AddNoteRes: action.payload,
        successMsg: action.successMsg,
      };
    case ADD_NOTE_FAIL:
      return {
        ...state,
        AddNoteRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case ADD_NOTE_UPDATE_API_MSG:
      return {
        ...state,
        AddNoteRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case ADD_NOTE_UPDATE_API_RES:
      return {
        ...state,
        AddNoteRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
